module.exports = __webpack_public_path__ + "static/slide-01-b4ba35fcb25b5bd73547c53a03d1736e.jpg";